import EntityCell from '@/components/Reports/Cell/EntityCell.vue'

const config = {
  cellRenderer: EntityCell
}
export default {
  type: 'Entity',
  config
}
